export enum CardsStackedVariants {
  Copy = 'Copy',
  Image = 'Image', // deprecated for ImageFullBleed
  ImageFullBleed = 'Image Full Bleed',
  ImageV2 = 'Image V2', // deprecated for ImageAboveCopy
  ImageAboveCopy = 'Image Above Copy',
  Icon = 'Icon',
}
